import {storeUtils} from '@fanfanlo'
export const permissionStorage = storeUtils.namespace('permission-droid/android')